export const soupData = [
  {
    type: '日式',
    name: '相撲鍋湯底',
    flag: 'jp.svg',
    hotpot: 'hotpot01',
    soup: 'soup01',
    intro: '充分融合雞湯的甘美與豬大骨湯的醇厚，並加入柴魚及昆布提鮮，無論是燉煮蔬菜或肉類合宜。',
    tags: [{ text: '風味淡雅' }, { text: '甘甜' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/8917557',
    comments: [
      '這是我們家最喜歡的湯頭口味，因為與任何蔬菜類、丸子類、肉類都很搭，所以回購次數最多，而且小孩最能接受。',
      '口味鹹淡適中，可以與多種蔬菜或湯料搭配，食用上的口味多變，不會蓋過食材本身的味道。',
      '很好喝！剛開始出湯底的時候，每一種都買回家試試，最喜歡這個！隨便加什麼料進去都很搭，適合懶人料理，哈哈。',
    ],
  },
  {
    type: '日式',
    name: '壽喜燒湯底',
    flag: 'jp.svg',
    hotpot: 'hotpot02',
    soup: 'soup02',
    intro: '以醬油為基底加入味醂、柴魚精華調味，充分釋放香醇醬香與酒香，適合煨煮肉類或烏龍麵品嚐。',
    tags: [{ text: '香醇醬香與酒香' }, { text: '濃且鹹' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/8917554',
    comments: [
      '一直以來都很喜歡吃壽喜燒醬香底料鹹甜滋味讓人愛不釋手無論牛肉豬肉，煮肉片也是一絕。',
      '跟店面賣的高級壽喜燒味道一樣，用89元就可以買到高檔的味道，還可以加自己喜歡的料，超讚！',
      '濃郁醬香且帶有糖跟味醂甜香的壽喜燒鍋底很適合在家裡烹煮時作為基底來搭配肉片、蔬菜跟烏龍麵。',
    ],
  },
  {
    type: '日式',
    name: '蘿蔔泥醬露湯底',
    flag: 'jp.svg',
    hotpot: 'hotpot03',
    soup: 'soup03',
    intro: '將醬油與雪花般的蘿蔔泥添加於湯中調煮，可感受蘿蔔泥顆粒口感及鮮甜感，適合煮食豬肉與蔬菜的清爽湯品。',
    tags: [{ text: '清爽鮮甜' }, { text: '雪鍋' }, { text: '雪見鍋' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/8917555',
    comments: [
      '口味不會太鹹，較剛好。蘿蔔泥多多很實在，搭配台式或日式料理皆適合，還可也當做天婦羅沾醬。',
      '最喜歡醬油的香氣搭配蘿蔔泥解膩的組合，很適合拿來煮火鍋，放什麼配料都很美味，煮成湯麵也非常可以！',
      '甘甜嫩滑又不死鹹，甜度爽口，最適合做烏龍麵或蔬菜湯。',
    ],
  },
  {
    type: '日式',
    name: '辣味柚香雞湯底',
    flag: 'jp.svg',
    hotpot: 'hotpot05',
    soup: 'soup05',
    intro: '甘醇雞骨高湯結合酸甜葡萄柚汁，加入辣椒粉提出辛香層次，風味清爽的開胃湯品。',
    tags: [{ text: '酸香風味' }, { text: '清爽開胃' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/8917556',
    comments: [
      '湯底清甜不膩，適合搭配鮮蝦、肉片和時蔬下去一起煮，再加入麻辣風味的即時拉麵真的非常美味！',
      '柚香湯底比較少見，湯頭清新、不膩口，柚子味也很夠，辣度對平常不怎麼吃辣的人來說也能入門！',
      '很喜歡淡淡的柚子香，微辣的口味也很棒，風味在外面火鍋店不常見，會一直想持續回購。',
    ],
  },
  {
    type: '台式',
    name: '蔥香鴨骨湯底',
    flag: 'tw.svg',
    hotpot: 'hotpot04',
    soup: 'soup04',
    intro: '將鴨骨與青蔥煎炒產生濃郁香氣後，加入醬油及味醂，與鴨骨精華充分結合，可搭配麵及蔬菜一同品嚐。',
    tags: [{ text: '風味清爽' }, { text: '溫順不膩口' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/8917560',
    comments: [
      '第一次喝就愛上，很清香，適合煮火鍋、湯麵、關東煮都非常的適合！',
      '濃郁的大蔥香氣搭配鴨骨，讓人回憶日本旅遊時光，彷彿置身日本，正吃著暖暖的熱鴨湯蕎麥麵～',
      '淡淡的蔥香屬於清甜類型的湯底，不管是煮火鍋還是一些日常的清湯麵等都不錯！',
    ],
  },
  {
    type: '台式',
    name: '剝皮辣椒湯底',
    flag: 'tw.svg',
    hotpot: 'hotpot06',
    soup: 'soup06',
    intro: '剝皮辣椒切得細碎後入湯熬煮，帶出高湯的微辣甘甜，一款台灣家常的溫補湯品。',
    tags: [{ text: '風味微辣回甘' }, { text: '椒香暖胃' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/8917558',
    comments: [
      '以前用罐頭煮出來湯底覺得不太喜歡，但這包湯底顛覆我對剝皮辣椒湯底不好吃的印象，爸媽也喜歡～',
      '剝皮辣椒湯底辣的夠味，冬天喝一碗肚子軟呼呼的，非常舒服好喝！',
      '湯頭濃郁、剝皮辣椒的辣度適中。<br />配上自己喜愛的食材，吃了心情會很好的一餐。',
    ],
  },
  {
    type: '台式',
    name: '麻油雞湯底',
    flag: 'tw.svg',
    hotpot: 'hotpot07',
    soup: 'soup07',
    intro: '麻油與薑片煸炒出香氣後添加適量米酒及冰糖提出甜感，一款台灣家常的溫補湯品。',
    tags: [{ color: '#7F0019', text: '冬季限定販售' }, { text: '溫潤香醇' }, { text: '薑香暖身' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/8917577',
    comments: [
      '香氣濃郁，成分與一般市售麻油雞湯底相較之下單純許多，非常喜歡！拿來煮成炊飯也很好吃。',
      '只要加入雞肉，就可以快速喝到麻油雞湯，不用炒雞肉爆香燉煮，零廚藝新手也能輕鬆完成麻油雞湯。',
      '在家弄麻油雞很麻煩，想吃的時候加熱放入想吃的食材，一碗熱呼呼又美味的麻油湯品就好了，推薦！',
    ],
  },
  {
    type: '台式',
    name: '薑母鴨湯底',
    flag: 'tw.svg',
    hotpot: 'hotpot08',
    soup: 'soup08',
    intro: '爆炒薑片與麻油釋放出焦香後加入鴨骨高湯及米酒一同燉煮入味，一款適合於冬季的禦寒湯品。 ',
    tags: [{ color: '#7F0019', text: '冬季限定販售' }, { text: '薑香濃郁' }, { text: '薑暖驅寒' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/8917594',
    comments: [
      '通常薑母鴨要很多人一起吃，這款湯包可以一人在家隨時吃，湯頭和店裡鍋煮一樣，冬天必備湯品！',
      '我都拿它來煮蝦再加點米酒就非常好吃，省去了大把時間在熬湯，超級快速就煮好一道藥膳蝦湯。',
      '人在國外喝到這個真的是一秒回台灣，是家鄉的味道啊！！',
    ],
  },
  {
    type: '台式',
    name: '藥燉排骨湯底',
    flag: 'tw.svg',
    hotpot: 'hotpot09',
    soup: 'soup09',
    intro: '添加當歸、枸杞、甘草等多種中藥材，熬出甘醇濃郁香氣，一款隨時可享用的溫暖湯品。',
    tags: [{ color: '#7F0019', text: '冬季限定販售' }, { text: '藥香甘醇' }, { text: '溫補暖身' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/8917575',
    comments: [
      '藥膳香氣濃郁，湯底順口不油膩，即使不用準備藥燉滷包，也能輕鬆享受台灣風味。',
      '不用準備藥材熬煮，輕鬆就能喝到道地的藥燉湯，也很適合當成道地台灣味的伴手禮送給外國友人。',
      '有傳統藥燉排骨的風味，不輸給夜市的藥燉排骨！',
    ],
  },
  {
    type: '韓式',
    name: '雪濃牛骨湯底',
    flag: 'kr.svg',
    hotpot: 'hotpot10',
    soup: 'soup10',
    intro: '韓國傳統祭祀先農祭時飲用的湯品，以大骨慢熬成乳白湯色，搭配薑蒜提味，適合搭配米麵食的濃郁湯品。',
    tags: [{ text: '口味濃厚不膩口' }, { text: '鮮甜回甘' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/8917550',
    comments: [
      '口味醇厚，最喜歡加入大白菜和蒜苗燉煮，滋味甘甜鮮美，丟入快煮麵，冬天吃起來非常暖胃。',
      '突然想吃雪濃湯的時候，把這個湯包及冬粉和想加的蔬菜放進鍋子裡面一起煮非常方便！',
      '湯底濃厚，加入蔬菜、肉類配料都能夠非常完美的融合，是一般家裡比較難呈現出的味道！',
    ],
  },
  {
    type: '港式',
    name: '胡椒豬肚湯底',
    flag: 'hk.svg',
    hotpot: 'hotpot11',
    soup: 'soup11',
    intro: '豬骨湯底加入辛香料和米酒熬煮，醇厚湯頭散發微嗆白胡椒辛香，經典的港式煲湯湯底。',
    tags: [{ text: '胡椒辛香' }, { text: '溫潤濃郁' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/10653137',
    comments: [
      '淡淡胡椒味搭配豬肚清湯完全不嗆辣還很順口，搭配何種食材都非常速配，唯一推薦胡椒豬肚湯底。',
      '超級還原！胡椒味道也很突出，不像市售的湯底沒什麼味道，非常美味。',
      '本身喜歡口味偏重一點，胡椒豬肚鹹淡恰好，聞起來也很香～簡單加入菜及一些配料就好好吃。',
    ],
  },
  {
    type: '港式',
    name: '椰子雞湯底',
    flag: 'hk.svg',
    hotpot: 'hotpot12',
    soup: 'soup12',
    intro: '雞湯加入多種藥材一起熬煮，氣味清香清甜、溫潤滋補，經典的港式煲湯湯底。',
    tags: [{ text: '清香甘甜' }, { text: '溫潤滋補' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/10653138',
    comments: [
      '有加入中藥材，溫和滋補養生的煲湯，一般在家沒時間弄，有這個湯底真的好方便！',
      '湯頭味道很好，清甜的雞湯香氣十足，煮火鍋或湯麵都好吃。',
      '椰子清甜雞湯濃郁 喝完不會有負擔的清爽。',
    ],
  },
  {
    type: '港式',
    name: '沙嗲湯底',
    flag: 'hk.svg',
    hotpot: 'hotpot14',
    soup: 'soup12',
    intro: '雞湯加入多種藥材一起熬煮，氣味清香清甜、溫潤滋補，經典的港式煲湯湯底。',
    tags: [{ text: '清香甘甜' }, { text: '溫潤滋補' }],
    price: '89',
    link: 'https://shop.muji.tw/',
    comments: [
      '醤油の香ばしさとみたらしだれのあまじょっぱさが、どんな味になるのか気になる～',
      '醤油の香ばしさとみたらしだれのあまじょっぱさが、どんな味になるのか気になる～',
      '醤油の香ばしさとみたらしだれのあまじょっぱさが、どんな味になるのか気になる～',
    ],
  },
  {
    type: '泰式',
    name: '泰式酸辣湯底',
    flag: 'th.svg',
    hotpot: 'hotpot13',
    soup: 'soup13',
    intro: '各式香草平衡辣椒與魚露味道，酸中帶辣、散發獨有辛香，適合加入海鮮一起品嚐的泰式湯底。',
    tags: [{ text: '酸中帶辣' }, { text: '清爽不膩' }],
    price: '89',
    link: 'https://shop.muji.tw/SalePage/Index/10653139',
    comments: [
      '酸酸辣辣的很開胃，可以做熱湯也能做冷湯的湯底，ㄧ湯多用，適合每個季節享用。',
      '酸辣可口讓人食慾大增，對於食材也很百搭，不管是海鮮還是其他肉類亦或是蔬菜豆腐都很配。',
      '酸酸辣辣的，非常開胃解膩，又不會太過清淡或重口味。',
    ],
  },
];

export const rankData = [
  {
    id: 1,
    size: '',
    name: '雪濃牛骨湯底',
  },
  {
    id: 2,
    size: 'x2',
    name: '相撲鍋湯底',
  },
  {
    id: 3,
    size: 'x2',
    name: '蘿蔔泥醬露湯底',
  },
  {
    id: 4,
    size: 'x3',
    name: '辣味柚香雞湯底',
  },
  {
    id: 5,
    size: 'x3',
    name: '壽喜燒湯底',
  },
  {
    id: 6,
    size: 'x3',
    name: '剝皮辣椒湯底',
  },
  {
    id: 7,
    size: 'x3',
    name: '胡椒豬肚湯底',
  },
  {
    id: 8,
    size: 'x3',
    name: '蔥香鴨骨湯底',
  },
  {
    id: 9,
    size: 'x3',
    name: '泰式酸辣湯底',
  },
  {
    id: 10,
    size: 'x3',
    name: '麻油雞湯底',
  },
  {
    id: 11,
    size: 'x3',
    name: '藥燉排骨湯底',
  },
  {
    id: 12,
    size: 'x3',
    name: '薑母鴨湯底',
  },
  {
    id: 13,
    size: 'x3',
    name: '椰子雞湯底',
  },
];

export const reportData = [
  {
    id: 1,
    link: 'https://www.muji.tw/tw/feature/25ss/muji-market-valencia/',
    img: 'special01.jpg',
    text: '晚崙西亞​橙',
  },
  {
    id: 2,
    link: 'https://www.muji.tw/tw/curry/',
    img: 'special02.jpg',
    text: '無印良品的異國咖哩',
  },
  {
    id: 3,
    link: 'https://www.muji.tw/tw/feature/24aw/pasta/',
    img: 'special03.jpg',
    text: '無印良品的義大利麵與義大利麵醬',
  },
  {
    id: 4,
    link: 'https://shop.muji.tw/sb/style/',
    img: 'special04.jpg',
    text: '創意料理',
  },
  {
    id: 5,
    link: 'https://www.muji.tw/tw/feature/frozen-foods/',
    img: 'special05.jpg',
    text: '冷凍食品',
  },
  {
    id: 6,
    link: 'https://www.muji.tw/tw/muji-market-golden/',
    img: 'special06.jpg',
    text: '黃金廊道',
  },
];
